<ix-fieldset [title]="'Authentication' | translate" [formGroup]="form">
  <a href="https://truenas.com/storjsignup" target="_blank" ixTest="signup-for-account">
    {{ 'Sign up for account' | translate }}
  </a>

  <ix-input
    formControlName="access_key_id"
    [label]="'Access Key ID' | translate"
    [required]="true"
  ></ix-input>

  <ix-input
    formControlName="secret_access_key"
    [label]="'Secret Access Key' | translate"
    [required]="true"
  ></ix-input>
</ix-fieldset>
